<template>
  <div v-if="displayForm">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="description" />
    <div
      v-if="refundConfirmation && !submitted"
      class="refund-amount"
    >
      <p v-if="refundAmount">
        <b>Refund Amount:</b> {{ refundAmount }}
      </p>
      <!-- <p><b>2020 Event Credit Amount:</b> 100% of paid amount</p> -->
      <p><b>2021 Event Credit Amount:</b> {{ creditAmount }}</p>
    </div>
    <div
      v-if="submitted"
      class="change-request-success"
    >
      <p>
        {{
          refundConfirmation ?
            'Success! Your selected option has been submitted.' :
            'Success! Your event change request has been submitted.'
        }}
      </p>
      <br>
      <p>
        {{
          refundConfirmation ?
            'We will reach out to you directly with the appropriate communication on your selected option as soon as possible.' :
            'We will reach out to you directly with the appropriate communications on your event change request as soon as possible.'
        }}
      </p>
      <br>
      <p>Thank you!</p>
    </div>
    <form
      v-else
      class="change-request-form"
      @submit.prevent="refundConfirmation ? submitRefundConfirmation() : submitChangeRequest()"
    >
      <div class="form-group">
        <select
          v-model="preference"
          class="form-control"
          name="change_preference"
        >
          <option
            v-for="(option, index) in preferences"
            :key="index"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>
      <div
        v-if="!refundConfirmation"
        class="form-group"
      >
        <textarea
          id="change_request_comments"
          v-model="comments"
          class="form-control"
          :placeholder="$t('form.comments')"
          maxlength="2000"
          cols="30"
          rows="5"
          name="comments"
        />
        <label
          v-show="comments.length >= 2000"
          class="error"
          for="change_request_comments"
        >2000 character max</label>
      </div>
      <button
        type="submit"
        class="btn btn-secondary"
      >
        Submit
      </button>
    </form>
  </div>
</template>

<script>
import FetchCall from '../../../shared/local_fetch_call'

export default {
  data() {
    return {
      opportunityId: null,
      displayForm: false,
      refundConfirmation: false,
      refundAmount: null,
      creditAmount: null,
      submitted: false,
      preferences: [],
      description: null,
      preference: null,
      comments: ''
    }
  },

  created() {
    this.hideChangeRequest()
    this.opportunityId = this.$parent.$el.dataset.opportunityid
    this.refundAmount = this.$parent.$el.dataset.refundamount
    this.creditAmount = this.$parent.$el.dataset.creditamount
    this.refundConfirmation = true
    // this.refundConfirmation = this.refundAmount ? true : false
    if (this.opportunityId) {
      this.fetchRefundConfirmationData()
      // this.refundConfirmation ?
      //   this.fetchRefundConfirmationData() : this.fetchChangeRequestData()
    }
  },

  methods: {
    async fetchRefundConfirmationData() {
      let res = await FetchCall.fetchWithoutLocale(
        `/oa/opportunities/${this.opportunityId}/refund_confirmations.json`,
        'GET',
        null
      )

      const event = res.data.opportunity.event
      this.displayForm = event.eventChangeDisplayQng && !res.submitted

      if (this.displayForm) {
        this.showChangeRequest()

        this.description = event.refundConfirmationDescription
        let refundPreferences = event.refundConfirmationPreference
        this.preferences = refundPreferences.split(',')
        this.preference = this.preferences[0]

        if (res.submitted) this.submitted = res.submitted
      }
    },
    async fetchChangeRequestData() {
      let res = await FetchCall.fetchWithoutLocale(
        `/oa/opportunities/${this.opportunityId}/cancellations.json`,
        'GET',
        null
      )

      const event = res.data.opportunity.event
      this.displayForm = event.eventChangeDisplayQng

      if (this.displayForm) {
        this.showChangeRequest()

        this.description = event.eventChangeValuesDescription
        let changePreferences = event.eventChangePreference
        this.preferences = changePreferences.split(',')
        this.preference = this.preferences[0]

        if (res.submitted) {
          this.submitted = res.submitted
        }
      }

    },
    async submitRefundConfirmation() {
      console.log('Submitting refund confirmation')
      const formData = {
        confirmation_preference: this.preference
      }

      await FetchCall.fetchWithoutLocale(
        `/oa/opportunities/${this.opportunityId}/refund_confirmations.json`,
        'POST',
        JSON.stringify(formData)
      )
      this.submitted = true
    },
    async submitChangeRequest() {
      const formData = {
        cancellation_preference: this.preference,
        comments: this.comments.trim()
      }

      await FetchCall.fetchWithoutLocale(
        `/oa/opportunities/${this.opportunityId}/cancellations.json`,
        'POST',
        JSON.stringify(formData)
      )
      this.submitted = true
    },
    hideChangeRequest() {
      document.getElementsByClassName('opportunity-change-request')[0].style.display = 'none'
    },
    showChangeRequest() {
      document.getElementsByClassName('opportunity-change-request')[0].style.display = 'flex'
    }
  }
}
</script>
